import { render, staticRenderFns } from "./Ficha.vue?vue&type=template&id=4154a48d&scoped=true&"
import script from "./Ficha.vue?vue&type=script&lang=ts&"
export * from "./Ficha.vue?vue&type=script&lang=ts&"
import style0 from "./Ficha.vue?vue&type=style&index=0&id=4154a48d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4154a48d",
  null
  
)

export default component.exports